export default __webpack_public_path__ + "static/media/unnamed-1.e11b84be.gif";